import React, { useState } from "react";
import { Collapse, Button, List, Row, Col } from "antd";
import { DeleteOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import { CaretRightOutlined } from "@ant-design/icons";
import { useCart } from "../../../../contexts/cart";
import routes from "../../../../../routes";
import PageHeader from "../../../../components/PageHeader";
import { useAuth } from "../../../../contexts/auth";
import InputBox from "../../../../components/InputBox";
import * as roles from "../../../../constants/roles";
import "./style.css";

const { Panel } = Collapse;

const PackageBlock = ({ data }) => {
  const [showDetails, setShowDetails] = useState(false);
  const { sampleCount } = data;
  const [countForInputBox, setCountForInputBox] = useState(sampleCount);
  const { tests = [], cost } = data.package;
  const testCategories = {};
  const auth = useAuth();
  const currentUser = auth.loggedInUser;
  const company = currentUser.company;
  const priceVisible = company.priceVisible;

  tests.forEach((testObj) => {
    const categoryName = testObj?.test?.testCategory?.name;
    if (!testCategories[testObj?.test?.testCategory?._id]) {
      testCategories[testObj.test.testCategory._id] = {
        name: categoryName,
        parameters: [
          {
            name: testObj.test.parameter,
            id: testObj.test._id,
            price: testObj.price,
          },
        ],
      };
    } else {
      testCategories[testObj.test.testCategory._id].parameters.push({
        name: testObj.test.parameter,
        id: testObj.test._id,
        price: testObj.price,
      });
    }
  });

  const commodity = tests[0].test.commodity;

  const renderTestCategories = (categories) => {
    const rows = [];
    Object.keys(categories).forEach((key, index) => {
      const entry = categories[key];
      const parameters = entry.parameters || [];
      if (parameters.length) {
        rows.push(
          <Panel
            header={
              <span style={{ fontWeight: "bold", color: "#0a8080" }}>
                {entry.name}
              </span>
            }
            key={index}
            style={{
              marginBottom: 20,
              overflow: "hidden",
              backgroundColor: "#eff3f7",
              border: "0px",
              borderRadius: 4,
              color: "#0a8080",
            }}
            id="panelCartHeader"
          >
            <List
              itemLayout="horizontal"
              dataSource={parameters}
              renderItem={(item) => (
                <List.Item>
                  <List.Item.Meta
                    title={<span className="cartTitle">{item.name}</span>}
                  />
                  {currentUser.role === roles.COMPANY_ADMIN.name ||
                  priceVisible ? (
                    <div className="cartTitle"> ₹ {item.price}</div>
                  ) : (
                    ""
                  )}
                </List.Item>
              )}
            />
          </Panel>
        );
      }
    });
    return rows;
  };
  const cart = useCart();

  const handleDeletePackage = (toDelete) => {
    cart.removeFromCart(toDelete);
  };

  const changeSampleCount = (value, packageData) => {
    if (value > 100) {
      return null;
    } else if (value > 0) {
      setCountForInputBox(value);
    } else {
      setCountForInputBox(0);
    }
    cart.updateCart(
      {
        sampleCount: value,
        changeValueOfSampleCountPackageId: packageData._id,
      },
      () => {}
    );
  };
  return (
    <div className="packageBlockContainer">
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <p>
          <strong>Package:</strong> {data.package.name}
        </p>
        <div className="priceWidth">
          <p>
            {currentUser.role === roles.COMPANY_ADMIN.name || priceVisible
              ? `Price: ₹ ${sampleCount * cost}`
              : ""}
            <Button
              type="dashed"
              size="small"
              onClick={() => handleDeletePackage(data)}
              shape="circle"
              icon={<DeleteOutlined />}
            />
          </p>
        </div>
      </div>
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <div className="detailsContainer">
          <p>
            <strong>Commodity:</strong> {commodity?.name}
          </p>
          {showDetails ? (
            <div>
              <Collapse
                bordered={false}
                expandIconPosition="right"
                expandIcon={({ isActive }) => (
                  <CaretRightOutlined
                    style={{ color: "#0a8080" }}
                    rotate={isActive ? 90 : 0}
                  />
                )}
                style={{ background: "#fff" }}
              >
                {renderTestCategories(testCategories)}
              </Collapse>
              <p>Notes: {data.notes || "N/A"}</p>

              <p style={{ display: "flex", flexDirection: "row" }}>
                <span style={{ marginTop: "20px" }} id="cartSampleCount">
                  Sample Count:
                </span>
                <div style={{ marginLeft: "10px", width: "80px" }}>
                  <InputBox
                    type="number"
                    value={countForInputBox}
                    onChange={(e) => {
                      changeSampleCount(e.target.value, data);
                    }}
                    min={0}
                    max={100}
                    noBottomMargin={true}
                  />
                </div>
              </p>
            </div>
          ) : (
            ""
          )}
        </div>
        <div className="detailsWidth">
          {showDetails ? (
            <p
              onClick={() => setShowDetails(false)}
              style={{ textDecoration: "underline", cursor: "pointer" }}
            >
              Hide Details
            </p>
          ) : (
            <p
              onClick={() => setShowDetails(true)}
              style={{ textDecoration: "underline", cursor: "pointer" }}
            >
              More Details
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

const CartSummaryPage = () => {
  const cart = useCart();
  const cartDetails = cart.details || {};
  const { packages = [] } = cartDetails;
  const cartExists = cartDetails._id && packages.length;
  const auth = useAuth();
  const currentUser = auth.loggedInUser;
  const company = currentUser.company;
  const priceVisible = company.priceVisible;
  let invalidSampleCount = packages.some((pack) => pack.sampleCount === 0);

  return !cartExists ? (
    <Row gutter={32} style={{ height: "100%" }}>
      <Col span={24}>
        <div className="bgCartSummaryPage" />
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <h1 style={{ color: "#3F3D56", fontSize: 24 }}>
            Looks like there are no items in your cart
          </h1>
          <Link to={routes.placeOrder}>
            <Button type="primary">Book Tests</Button>
          </Link>
        </div>
      </Col>
    </Row>
  ) : (
    <div>
      <PageHeader title="Cart Summary" />
      <div className="container">
        <div className="packagesDiv">
          {packages.map((packageDetails) => (
            <PackageBlock key={packageDetails._id} data={packageDetails} />
          ))}
        </div>
        <div className="orderSummaryContainer">
          {currentUser.role === roles.COMPANY_ADMIN.name || priceVisible ? (
            <div>
              {" "}
              <h1>Order Summary</h1>
              <div>
                <p>Total: ₹ {cartDetails.total}</p>
              </div>
              <div>
                <p>Discount: (-) {cartDetails.discount}</p>
              </div>
              {/* <div>
            <p>Shipping Charges: ₹ {cartDetails.shipping}</p>
          </div> */}
              <div>
                <p>Final Payable: ₹ {cartDetails.grandTotal}</p>
              </div>
            </div>
          ) : (
            ""
          )}

          <div style={{ width: "100%", marginBottom: 30 }} id="cartButtons">
            <Link to={routes.placeOrder}>
              <Button block type="secondary">
                Add More Tests
              </Button>
            </Link>
          </div>
          <div style={{ width: "100%" }} id="cartButtons">
            <Link to={routes.cartAddress}>
              <Button block type="primary" disabled={invalidSampleCount}>
                Checkout
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CartSummaryPage;
